/**
 * PreviewLiveBadge — live / stale / updating status chip.
 */

import { FC } from 'react';
import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

export interface PreviewLiveBadgeProps {
  isFetching: boolean;
  isStale: boolean;
  compact?: boolean;
}

const PreviewLiveBadge: FC<PreviewLiveBadgeProps> = ({
  isFetching,
  isStale,
  compact = false,
}) => (
  <span
    className={cn(
      'inline-flex items-center gap-1.5 rounded-full border font-medium',
      compact ? 'px-1.5 py-0 text-[10px]' : 'px-2 py-0.5 text-[11px]',
      isFetching
        ? 'border-primary/40 bg-primary/5 text-primary'
        : isStale
          ? 'border-amber-400/40 bg-amber-500/5 text-amber-600'
          : 'border-emerald-400/40 bg-emerald-500/5 text-emerald-600',
    )}
  >
    {isFetching ? (
      <Loader2 className="h-3 w-3 animate-spin" aria-hidden />
    ) : (
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden />
    )}
    {isFetching ? 'Updating…' : isStale ? 'Stale' : 'Live'}
  </span>
);

export default PreviewLiveBadge;
